import type { InvoiceFormValues } from "./schemas/invoiceForm"

import { FieldGroupEnum } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const INVOICES_SEARCH_PLACEHOLDER = "Search by Vendor Name, Vendor Invoice #, or Amount"

export const INVOICE_TOTAL_MAX = 999_999.99

export const INVOICE_AMOUNT_TOLERANCE = 0.001

export const PAST_ACCOUNTING_PERIOD_WARNING =
  "You've entered a transaction date that falls in a previous accounting period. Please double-check before clicking Save."

export const FUTURE_ACCOUNTING_PERIOD_ERROR =
  "Future accounting periods are not allowed. Please select a date within the current accounting period."

export const VENDOR_OPTIONS_LIMIT = 1000

export type InvoiceDocumentFieldGroup = FieldGroupEnum.InvoiceInvoice | FieldGroupEnum.InvoiceOther

export const INVOICE_DOCUMENT_TYPE_TO_LABEL: Record<InvoiceDocumentFieldGroup, string> = {
  [FieldGroupEnum.InvoiceInvoice]: "Invoice",
  [FieldGroupEnum.InvoiceOther]: "Other",
}

export const INVOICE_DOCUMENT_TYPE_OPTIONS: Option<InvoiceDocumentFieldGroup>[] = [
  { value: FieldGroupEnum.InvoiceInvoice, label: INVOICE_DOCUMENT_TYPE_TO_LABEL[FieldGroupEnum.InvoiceInvoice] },
  { value: FieldGroupEnum.InvoiceOther, label: INVOICE_DOCUMENT_TYPE_TO_LABEL[FieldGroupEnum.InvoiceOther] },
]

export const DEFAULT_INVOICE_FORM_VALUES: InvoiceFormValues = {
  vendorId: "",
  invoiceNumber: "",
  invoiceDate: "",
  dueDate: "",
  totalAmount: null as unknown as number,
  printedCheck: false,
  expenseLines: [{ expenseAccountId: "", amount: null }],
  attachments: [],
  comment: "",
}
